module.exports = __webpack_public_path__ + "img/bg5.64e51e0e.png";